(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7502"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7502"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("afp6i", function(module, exports) {
class Brands {
    constructor(section){
        if (!section) return;
        this.placeholder = section.querySelector('.brands-list__image-wrapper');
        this.brandList = section.querySelector('.brands-list');
        this.brandLetters = section.querySelector('.brands-letters');
        this.brandLetterLinks = this.brandLetters.querySelectorAll('.slider-item > a[href]');
        if (this.brandList) this.brands = this.brandList.querySelectorAll('.brands-item');
        if (!this.brands.length > 0) return;
        this.init();
    }
    init() {
        const _this = this;
        _this.brands.forEach((brand)=>{
            brand.addEventListener('mouseover', _this.onMouseOver.bind(_this));
        });
        _this.brandLetterLinks.forEach((letterLink)=>{
            letterLink.addEventListener('click', function(event) {
                event.preventDefault();
                const linkTo = letterLink.getAttribute('href');
                // Make sure the link is meant to go to a div
                if (linkTo.substring(0, 1) != '#') return;
                const letter = linkTo.substring(1);
                const brands = _this.brandList.querySelectorAll(`.brands-item`);
                brands.forEach((brand)=>{
                    brand.classList.add('is-hidden');
                });
                if (letter == 'All') {
                    const brands = _this.brandList.querySelectorAll(`.brands-item`);
                    brands.forEach((brand)=>{
                        brand.classList.remove('is-hidden');
                    });
                } else if (letter == '0-9') {
                    const allNumbers = '0,1,2,3,4,5,6,7,8,9';
                    const numbers = allNumbers.split(',');
                    numbers.forEach((number)=>{
                        const brand = _this.brandList.querySelectorAll(`.brands-item[data-letter="brand-letter-${number}"]`);
                        brand.forEach((bra)=>{
                            bra.classList.remove('is-hidden');
                        });
                    });
                } else {
                    const brandsWithLetter = _this.brandList.querySelectorAll(`.brands-item[data-letter="brand-letter-${letter}"]`);
                    brandsWithLetter.forEach((brand)=>{
                        brand.classList.remove('is-hidden');
                    });
                }
                // remove all selected classes
                _this.brandLetterLinks.forEach((link)=>{
                    link.classList.remove('is-selected');
                });
                // add selected class to current link
                letterLink.classList.add('is-selected');
            });
        });
        window.addEventListener('scroll', function() {
            _this.brandLettersSticky();
        });
    }
    brandLettersSticky() {
        if (!this.brandLetters) return;
        this.brandLetters.classList.toggle('is-sticky', window.scrollY > 0);
        const headerSection = document.querySelector('.shopify-section.header-section');
        headerSection.classList.toggle('not-sticky', window.scrollY > 100);
        const stickyHeader = document.querySelector('.header.is-sticky');
        if (stickyHeader) stickyHeader.classList.toggle('header--shadow-medium', window.scrollY <= 0);
    }
    onMouseOver(event) {
        const brand = event.currentTarget;
        if (this.placeholder) {
            const brandImg = brand.querySelector('.brands-list__image');
            if (brandImg) {
                const clonedbrandImg = brandImg.cloneNode(true);
                clonedbrandImg.setAttribute('class', '');
                clonedbrandImg.classList.add('brands-list__image');
                this.placeholder.innerHTML = clonedbrandImg.outerHTML;
            }
        }
    }
}
const brandsSections = document.querySelectorAll('.shopify-section.section-brands');
if (!brandsSections.length > 0) return;
brandsSections.forEach((brandsSection)=>{
    if (brandsSection) new Brands(brandsSection);
});

});

(function() {
    const mainProduct = document.querySelector('.product-information');
    if (!mainProduct) return;
    const productID = mainProduct.dataset.product_id;
    document.addEventListener('DOMContentLoaded', async ()=>{
        const variantsInventoryLevels = await getVariantsInventoryLevels(productID);
        const product = await getProduct(productID);
        productAppointo();
        const targetNode = document.querySelector("#main-product-cart__holder.add_to_cart_holder");
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };
        const callback = (mutationList, observer)=>{
            for (const mutation of mutationList){
                if (mutation.type === "childList") productAppointo();
                else if (mutation.type === "attributes" && mutation.target.classList.contains('.appointo-custom-styles')) observer.disconnect();
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
        const productAndVariantsInventoryOnLoad = new CustomEvent('productAndVariantsInventoryOnLoad', {
            detail: {
                product: product,
                variantsInventoryLevels: variantsInventoryLevels
            }
        });
        document.dispatchEvent(productAndVariantsInventoryOnLoad);
    });
    function productAppointo() {
        const appointoBtn = mainProduct.querySelector('#appointo-btn');
        if (appointoBtn === null || appointoBtn === undefined) return;
        if (appointoBtn.classList.contains('d-none')) appointoBtn.classList.remove('d-none');
        appointoBtn.classList.add('appointo-custom-styles');
        appointoBtn.closest('div').addEventListener('mouseover', function() {
            appointoBtn.setAttribute('style', 'background:black !important; color:white !important');
        });
        appointoBtn.closest('div').addEventListener('mouseleave', function() {
            appointoBtn.setAttribute('style', 'background:white !important; color:black !important');
        });
        appointoBtn.nextElementSibling.classList.add('d-none');
        if (document.querySelector('fieldset .variant-picker')) document.querySelectorAll('fieldset .variant-picker').forEach((el)=>el.classList.add('d-none'));
    }
    document.addEventListener("product:variant-change", async function(e) {
        const variantsInventoryLevels = await getVariantsInventoryLevels(productID);
        const product = await getProduct(productID);
        const productOnChange = new CustomEvent('productOnChange', {
            detail: {
                product: product,
                variantsInventoryLevels: variantsInventoryLevels
            }
        });
        document.dispatchEvent(productOnChange);
    });
    async function getVariantsInventoryLevels(productID) {
        if (!productID) return;
        const domainName = 'https://netlify.blacklemon.dk';
        const storeName = 'plaza-ure-smykker';
        const APIURL = `${domainName}/.netlify/functions/getProductInventoryLevels?store=${storeName}&prodId=${productID}`;
        try {
            const response = await fetch(APIURL);
            if (response?.ok) return await response.json();
        } catch (error) {
            console.log('There was an error', error);
        }
    }
    if (document.querySelector('.notify-me-btn')) document.querySelector('.notify-me-btn').addEventListener('click', function(el) {
        productBackInStockMain();
    });
    function productBackInStockMain() {
        const targetNode = document.querySelector('#klaviyo-bis-iframe');
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };
        const callback = (mutationList, observer)=>{
            for (const mutation of mutationList)if (mutation.type === "attributes") productBackInStockModal();
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
    function productBackInStockModal() {
        const envelopeIcon = ` <svg xmlns="http://www.w3.org/2000/svg" width="32" height="23" viewBox="0 0 32 23" fill="none">
    <path d="M29.7143 0H2.28571C1.67951 0 1.09812 0.242321 0.66947 0.673654C0.240816 1.10499 0 1.69 0 2.3V20.7C0 21.31 0.240816 21.895 0.66947 22.3263C1.09812 22.7577 1.67951 23 2.28571 23H29.7143C30.3205 23 30.9019 22.7577 31.3305 22.3263C31.7592 21.895 32 21.31 32 20.7V2.3C32 1.69 31.7592 1.10499 31.3305 0.673654C30.9019 0.242321 30.3205 0 29.7143 0ZM27.2 2.3L16 10.097L4.8 2.3H27.2ZM2.28571 20.7V3.3465L15.3486 12.443C15.5399 12.5765 15.7672 12.6481 16 12.6481C16.2328 12.6481 16.4601 12.5765 16.6514 12.443L29.7143 3.3465V20.7H2.28571Z" fill="black"/>
  </svg>`;
        const iframeBody = document.querySelector('#klaviyo-bis-iframe').contentWindow.document.body;
        const successButton = iframeBody.querySelector('button.btn-success');
        if (successButton) {
            const successButtonText = successButton?.innerText;
            successButton.innerHTML = envelopeIcon + '<span>' + successButtonText + '</span>';
        }
        const closeKlaviyo = iframeBody.querySelector('.klaviyo-bis-close');
        if (closeKlaviyo) closeKlaviyo.innerHTML = `
        <svg class='close klaviyo-bis-close' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M15 15L3 3M15 3L3 15" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    `;
        successButton.addEventListener('click', function(el) {
            const targetNode = iframeBody.querySelector('#completed_message');
            const config = {
                attributes: true,
                childList: true,
                subtree: true
            };
            const callback = (mutationList, observer)=>{
                for (const mutation of mutationList)if (mutation.type === "attributes") productBackInStockSubmitted(iframeBody, successButton, envelopeIcon);
            };
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        });
    }
    function productBackInStockSubmitted(iframeBody, successButton, envelopeIcon) {
        if (successButton) {
            if (iframeBody.querySelector('#container p')) iframeBody.querySelector('#container p').remove();
            if (iframeBody.querySelector('#container #email')) iframeBody.querySelector('#container #email').remove();
            if (iframeBody.querySelector('#container #variant_select')) iframeBody.querySelector('#container #variant_select').remove();
            if (iframeBody.querySelector('#container #newsletter_subscription')) iframeBody.querySelector('#container #newsletter_subscription').remove();
            if (!iframeBody.querySelector('.feedback-envelope-icon')) {
                const feeedbackIcon = document.createElement('div');
                feeedbackIcon.classList.add('feedback-envelope-icon');
                feeedbackIcon.innerHTML = envelopeIcon;
                iframeBody.querySelector('#completed_message div').parentNode.insertBefore(feeedbackIcon, iframeBody.querySelector('#completed_message div'));
            }
        }
    }
    async function getProduct(productID) {
        if (!productID) return;
        const domainName = 'https://netlify.blacklemon.dk';
        const storeName = 'plaza-ure-smykker';
        const APIURL = `${domainName}/.netlify/functions/getProduct?store=${storeName}&id=${productID}`;
        try {
            const response = await fetch(APIURL);
            if (response?.ok) return await response.json();
        } catch (error) {
            console.log('There was an error', error);
        }
    }
})();


parcelRequire("afp6i");
if (!customElements.get('gift-wrap')) {
    class GiftWrap extends HTMLElement {
        constructor(){
            super();
        }
        async connectedCallback() {
            const label = this.querySelector('label.gift-wrap-checker');
            const checkbox = label?.querySelector('input[gift-wrap]');
            const productId = checkbox?.getAttribute("giftwrap-variant");
            const cartDrawerForm = document.querySelector('#cart-drawer-form');
            const cart = await this.getCart();
            const giftWrapInCart = this.isGiftInCart(cart?.items, productId);
            giftWrapInCart ? checkbox.checked = true : checkbox.checked = false;
            label.addEventListener('click', ()=>this.handleLabelClick(checkbox, productId, cartDrawerForm));
        }
        async getCart() {
            const response = await fetch("/cart.js", {
                method: "GET",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return response.json();
        }
        isGiftInCart(items, productId) {
            if (!items || !Array.isArray(items) || items.length === 0 || !productId) {
                console.warn("\u274C No items found");
                return false;
            }
            return items.some((item)=>item.id.toString() === productId);
        }
        async handleLabelClick(checkbox, productId, cartDrawerForm) {
            if (!checkbox || !productId || !cartDrawerForm) {
                console.warn("\u274C No checkbox or productId or cartDrawerForm found");
                return;
            }
            checkbox.disabled = true;
            checkbox.checked = !checkbox.checked;
            // Update cart when gift wrap is clicked
            cartDrawerForm.classList.add('loading');
            if (checkbox.checked) await this.addProductToCart(productId);
            else await this.removeProductFromCart(productId);
            await this.updateCartTotal();
            cartDrawerForm.classList.remove('loading');
            checkbox.disabled = false;
        }
        async updateCartTotal() {
            const updatedCart = await this.getCart();
            const format = window.theme.settings.money_with_currency_format;
            const cartTotalPrice = formatMoney(updatedCart.total_price, format);
            const totalEl = document.querySelector("#cart-drawer-total");
            if (totalEl) totalEl.textContent = `${cartTotalPrice}`;
        }
        async addProductToCart(id) {
            if (!id) return;
            return await fetch("/cart/add.js", {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: id,
                            quantity: 1
                        }
                    ]
                })
            });
        }
        async removeProductFromCart(id) {
            if (!id) return;
            return await fetch("/cart/change.js", {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: id,
                    quantity: 0
                })
            });
        }
    }
    customElements.define('gift-wrap', GiftWrap);
}


/**
 *  @class
 *  @function MixMatch
 */ class $db82db20e0723b9a$var$MixMatch {
    constructor(section){
        if (!section) return;
        this.container = section.querySelector('#Mix-Match-Drawer');
        this.button = section.querySelectorAll('.mix-max-toggle');
        this.setupEventListeners();
    }
    setupEventListeners() {
        this.button.forEach((item, i)=>{
            item.addEventListener('click', (event)=>{
                event.preventDefault();
                document.getElementsByTagName("body")[0].classList.toggle('open-cc');
                this.container.classList.toggle('active');
                if (this.container.classList.contains('active')) dispatchCustomEvent('mix-match-drawer:open');
                return false;
            });
        });
    }
}
const $db82db20e0723b9a$var$mixMatches = Array.from(document.querySelectorAll('[data-mix-match]'));
$db82db20e0723b9a$var$mixMatches.forEach((mixMatch)=>{
    if (mixMatch) new $db82db20e0723b9a$var$MixMatch(mixMatch);
});


let $a36476dd5ca8c315$var$scalePointInfos = document.querySelectorAll('.scale-point-info');
const $a36476dd5ca8c315$var$scalePointWrapper = document.querySelector('.side-panel-scale-point');
const $a36476dd5ca8c315$var$scalePointTextarea = document.querySelector('input.scale-point-text-area');
function $a36476dd5ca8c315$var$scalePointInfo() {
    $a36476dd5ca8c315$var$scalePointInfos.forEach((scalePointInfo)=>{
        if (!scalePointInfo) return;
        let scalePointInfoText = scalePointInfo.querySelector('.scale-point-info-text');
        if (scalePointInfoText) {
            if (window.matchMedia('screen and (max-width: 767px)')) scalePointInfo.addEventListener('click', function(e) {
                e.preventDefault();
                if (!scalePointInfo) return;
                if (scalePointInfoText.style.visibility == 'hidden') scalePointInfoText.style.visibility = 'visible';
                else scalePointInfoText.style.visibility = 'hidden';
            });
        }
    });
}
function $a36476dd5ca8c315$var$scalePointInputOnChange() {
    const scalePointWrapperUpdated = document.querySelector('.side-panel-scale-point');
    const scalePointTextareaUpdated = scalePointWrapperUpdated.querySelector('input.scale-point-text-area');
    scalePointTextareaUpdated.addEventListener("input", function(event) {
        const errorEl = scalePointWrapperUpdated.querySelector("[scale-point-error-msg]");
        let isErrorPresent = false;
        if (!errorEl) return;
        let regex = /[^\w\s.,!?æøåÆØÅ]/g;
        this.value = this.value.replace(regex, '');
        let valueLength = this.value.length;
        let containsLetter = /[a-zA-ZæøåÆØÅ]/.test(this.value);
        if (!containsLetter) isErrorPresent = true;
        if (valueLength !== 10) isErrorPresent = true;
        if (valueLength === 0) isErrorPresent = false;
        if (isErrorPresent) errorEl.classList.remove('d-none');
        else errorEl.classList.add('d-none');
    });
}
const $a36476dd5ca8c315$var$handleCartUpdate = ()=>{
    setTimeout(()=>{
        let scalePointInfos = document.querySelectorAll('.scale-point-info');
        const scalePointTextarea = document.querySelector('input.scale-point-text-area');
        if (scalePointInfos) $a36476dd5ca8c315$var$scalePointInfo();
        if (scalePointTextarea) $a36476dd5ca8c315$var$scalePointInputOnChange();
    }, 2000);
};
document.addEventListener("cart:item-removed", $a36476dd5ca8c315$var$handleCartUpdate);
document.addEventListener("cart:item-updated", $a36476dd5ca8c315$var$handleCartUpdate);
document.addEventListener("cart-drawer:open", $a36476dd5ca8c315$var$handleCartUpdate);
if ($a36476dd5ca8c315$var$scalePointInfos) $a36476dd5ca8c315$var$scalePointInfo();
if ($a36476dd5ca8c315$var$scalePointTextarea) $a36476dd5ca8c315$var$scalePointInputOnChange();


const $8e8ca2e53959d55d$var$personalCardWrapper = document.querySelector('.side-panel-personal-card');
if ($8e8ca2e53959d55d$var$personalCardWrapper) $8e8ca2e53959d55d$var$personalCardScripts();
function $8e8ca2e53959d55d$var$personalCardScripts() {
    const personalCardWrapperUpdated = document.querySelector('.side-panel-personal-card');
    if (!personalCardWrapperUpdated) return;
    const personalCardTextarea = personalCardWrapperUpdated.querySelector('textarea.personal-card-text-area');
    function sanitizeInput(value) {
        const emojiRegex = /([\p{Extended_Pictographic}|\u200D]+)/gu;
        const allowedCharsRegex = /[^\w\s.,!?æøåÆØÅ:\-']/g;
        return value.replace(emojiRegex, '').replace(allowedCharsRegex, '');
    }
    personalCardTextarea.addEventListener("input", function() {
        this.value = sanitizeInput(this.value);
    });
    personalCardTextarea.addEventListener("paste", function(e) {
        e.preventDefault();
        const pasted = (e.clipboardData || window.clipboardData).getData('text');
        const sanitized = sanitizeInput(pasted);
        document.execCommand("insertText", false, sanitized);
    });
}
const $8e8ca2e53959d55d$var$handleCartUpdate = ()=>{
    setTimeout(()=>{
        if ($8e8ca2e53959d55d$var$personalCardWrapper) $8e8ca2e53959d55d$var$personalCardScripts();
    }, 2000);
};
document.addEventListener("cart:item-removed", $8e8ca2e53959d55d$var$handleCartUpdate);
document.addEventListener("cart:item-updated", $8e8ca2e53959d55d$var$handleCartUpdate);
document.addEventListener("cart-drawer:open", $8e8ca2e53959d55d$var$handleCartUpdate);


window.addEventListener("load", ()=>{
    if (!window.location.href.includes("products")) return;
    if (!document.querySelector(".pair_single_selector__btn_wrap")) return;
    document.querySelectorAll(".pair_single_selector__btn_wrap .button").forEach((btn)=>{
        btn.addEventListener("click", $0ccf9ef418da0593$var$toggleEarringQuantity);
    });
});
function $0ccf9ef418da0593$var$toggleEarringQuantity() {
    document.querySelectorAll(".pair_single_selector__btn_wrap .button").forEach((btn)=>{
        btn.classList.toggle("selected");
    });
    const quantity = document.querySelector(".pair_single_selector__btn_wrap .button.selected").dataset.quantity;
    document.querySelectorAll('input[name="items[0][quantity]"').forEach((input)=>input.value = quantity);
    document.querySelectorAll('quantity-selector input').forEach((input)=>input.value = quantity);
    if (parseInt(quantity) > 1) {
        document.querySelectorAll("[data-single-price]").forEach((singlePrice)=>singlePrice.classList.add("d-none"));
        document.querySelectorAll("[data-pair-price]").forEach((singlePrice)=>singlePrice.classList.remove("d-none"));
    } else {
        document.querySelectorAll("[data-single-price]").forEach((singlePrice)=>singlePrice.classList.remove("d-none"));
        document.querySelectorAll("[data-pair-price]").forEach((singlePrice)=>singlePrice.classList.add("d-none"));
    }
}


(function() {
    const sidePanel = document.createElement('div');
    sidePanel.classList.add('side-panel-wrapper');
    const pageWrapper = document.querySelector('#wrapper');
    if (sidePanel && pageWrapper) pageWrapper.appendChild(sidePanel);
    const storeAvailability = document.querySelector('.store-availability');
    if (!storeAvailability) return;
    const getPickupLocations = async ()=>{
        const domainName = 'https://netlify.blacklemon.dk';
        const storeName = 'plaza-ure-smykker';
        const metafieldKey = 'available_for_local_pickup';
        const namespace = 'custom';
        const APIURL = `${domainName}/.netlify/functions/getStoresByMetafield?store=${storeName}&metafieldKey=${metafieldKey}&namespace=${namespace}`;
        let response = null;
        try {
            response = await fetch(APIURL);
        } catch (error) {
            console.log('There was an error', error);
        }
        if (response?.ok) return await response.json();
    };
    document.addEventListener('DOMContentLoaded', async ()=>{
        const pickupLocations = await getPickupLocations();
        initStoreAvailability(pickupLocations);
    });
    function initStoreAvailability(pickupLocations) {
        const bundleProductsVariantIDs = storeAvailability.dataset.bundleProductVariantIds.split(',');
        const bundleProductIDs = document.querySelector('.store-availability')?.dataset?.bundleProductIds?.split(',');
        const variantID = document.querySelector('.product-information').dataset.variant_id;
        const inventoryNoticeThreshold = storeAvailability.dataset.inventoryNoticeThreshold;
        const showInventoryNotice = storeAvailability.dataset.showInventoryNotice;
        const sidePanel = storeAvailability.querySelector('.side-panel');
        const openSidePanel = storeAvailability.querySelector('[open-side-panel]');
        async function productAndVariantsInventoryOnLoad(event) {
            if (bundleProductIDs.length > 1) {
                const variantsInventoryLevels = await getBundleVariantInventoryLevels(bundleProductIDs);
                handleBundleInventory(variantsInventoryLevels, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, bundleProductsVariantIDs);
                async function getBundleVariantInventoryLevels(bundleProductIDs) {
                    const bundleSize = bundleProductIDs.length;
                    let inventoryData = [];
                    const promises = bundleProductIDs.map(async (productID)=>{
                        const data = await getVariantsInventoryLevels(productID);
                        return data;
                    });
                    inventoryData = await Promise.all(promises);
                    return inventoryData;
                }
                async function getVariantsInventoryLevels(productID) {
                    if (!productID) return;
                    const domainName = 'https://netlify.blacklemon.dk';
                    const storeName = 'plaza-ure-smykker';
                    const APIURL = `${domainName}/.netlify/functions/getProductInventoryLevels?store=${storeName}&prodId=${productID}`;
                    try {
                        const response = await fetch(APIURL);
                        if (response?.ok) return await response.json();
                    } catch (error) {
                        console.log('There was an error', error);
                    }
                }
            } else handleVariantInventory(event, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, variantID);
            document.removeEventListener('productAndVariantsInventoryOnLoad', productAndVariantsInventoryOnLoad);
        }
        openSidePanel.addEventListener('click', ()=>triggerSidePanel(true));
        function handleBundleInventory(variantsInventoryLevels, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, bundleProductsVariantIDs) {
            // filter pickup locations based on available variant inventory
            let availablePickupLocations = pickupLocations;
            let bundleSize = variantsInventoryLevels.length;
            for(let i = 0; i < bundleSize; i++){
                let variantInventory = variantsInventoryLevels[i][0]['inventory_quantities'];
                availablePickupLocations = availablePickupLocations.filter((location)=>variantInventory.map((variant)=>variant.name).includes(location.name) && location);
            }
            // filter variant inventory based on available pickup locations
            for(let i = 0; i < bundleSize; i++){
                variantsInventoryLevels[i][0]['inventory_quantities'] = variantsInventoryLevels[i][0]['inventory_quantities'].filter((variant)=>availablePickupLocations.map((location)=>location.name).includes(variant.name));
                variantsInventoryLevels[i][0]['inventory_quantities'] = variantsInventoryLevels[i][0]['inventory_quantities'];
            }
            // gather level of full bundle sets in each available location
            let availableBundleInventory = variantsInventoryLevels[0][0]['inventory_quantities'];
            for(let i = 1; i < bundleSize; i++){
                let variantInventory = variantsInventoryLevels[i][0]['inventory_quantities'];
                for(let i = 0; i < availableBundleInventory.length; i++)if (availableBundleInventory[i].level > variantInventory[i].level) availableBundleInventory[i].level = variantInventory[i].level;
            }
            const isOnlineExclusive = availableBundleInventory.find((variantLevels)=>variantLevels.name === "Weblager")?.level || 0;
            availablePickupLocations && renderLocations(availablePickupLocations, availableBundleInventory, inventoryNoticeThreshold, showInventoryNotice, isOnlineExclusive);
            return {
                availablePickupLocations: availablePickupLocations,
                availableBundleInventory: availableBundleInventory
            };
        }
        function handleVariantInventory(event, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, variantID) {
            const { variantsInventoryLevels: variantsInventoryLevels } = event.detail;
            const { inventory_quantities: inventory_quantities } = variantsInventoryLevels.find((inventory)=>inventory.id.includes(variantID));
            const isOnlineExclusive = inventory_quantities.find((variantLevels)=>variantLevels.name === "Weblager")?.level || 0;
            if (inventory_quantities && pickupLocations) {
                let availableVariantInventory = inventory_quantities.filter((variantInv)=>variantInv.level > 0);
                // filter pickup locations based on available variant inventory
                let availablePickupLocations = pickupLocations.filter((location)=>availableVariantInventory.map((variant)=>variant.name).includes(location.name) && location);
                // filter variant inventory based on available pickup locations
                availableVariantInventory = availableVariantInventory.filter((variant)=>availablePickupLocations.map((location)=>location.name).includes(variant.name));
                availableVariantInventory;
                availablePickupLocations && renderLocations(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold, showInventoryNotice, isOnlineExclusive);
                return {
                    availablePickupLocations: availablePickupLocations,
                    availableVariantInventory: availableVariantInventory
                };
            }
            document.removeEventListener('productAndVariantsInventoryOnLoad', handleVariantInventory);
        }
        function renderLocations(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold, showInventoryNotice, isOnlineExclusive) {
            if (availablePickupLocations && availablePickupLocations.length) {
                // Remove locations in side panel if any exists
                let locations = document.querySelector('.side-panel-wrapper-template .pickup-locations');
                let firstChild = locations.firstElementChild;
                while(firstChild){
                    firstChild.remove();
                    firstChild = locations.firstElementChild;
                }
                const totalAvailableItems = availableVariantInventory.reduce((acc, curr)=>acc + curr.level, 0);
                if (showInventoryNotice === 'low' && totalAvailableItems > inventoryNoticeThreshold) ;
                else {
                    const noticeColor = totalAvailableItems > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low';
                    // Update store availability in product page
                    storeAvailability.querySelector('.in-stores').classList.remove('d-none');
                    storeAvailability.querySelector('.online-exclusive').classList.add('d-none');
                    storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('d-none');
                    storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('product-inventory-notice--normal', 'product-inventory-notice--low');
                    storeAvailability.querySelector('.product-inventory-notice.pp').classList.add('product-inventory-notice--' + noticeColor);
                    storeAvailability.querySelector('.pickup-availabilities-size').innerText = `${availablePickupLocations.length}`;
                    // Update pickup locations in side panel popup
                    const temp = document.querySelector("template.pickup");
                    const itemHtml = temp.content.querySelector(".pickup-location");
                    availablePickupLocations.map((location)=>{
                        const variantLevel = availableVariantInventory.find((vLevel)=>vLevel.name === location.name).level;
                        const noticeColor = variantLevel > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low';
                        const node = document.importNode(itemHtml, true);
                        node.querySelector('.product-inventory-notice').classList.add('product-inventory-notice--' + noticeColor);
                        node.querySelector('.location-name').textContent = location.name;
                        if (location.distance) node.querySelector('.pickup-location__distance').textContent = '(' + location.distance + 'km)';
                        node.querySelector('.pickup-location__items').textContent = variantLevel;
                        node.querySelector('.pickup-location__address .address1').textContent = location?.address?.address1;
                        node.querySelector('.pickup-location__address .zip').textContent = location?.address?.zip;
                        node.querySelector('.pickup-location__address .city').textContent = location?.address?.city;
                        document.querySelector('.side-panel-wrapper-template .pickup-locations').appendChild(node);
                    });
                }
            } else if (isOnlineExclusive > 0) {
                // Remove existing information
                storeAvailability.querySelector('.in-stores').classList.add('d-none');
                storeAvailability.querySelector('.online-exclusive').classList.remove('d-none');
                const noticeColor = isOnlineExclusive > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low';
                storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('product-inventory-notice--normal', 'product-inventory-notice--low');
                storeAvailability.querySelector('.online-exclusive .product-inventory-notice').classList.add('product-inventory-notice--' + noticeColor);
                storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('d-none');
            } else storeAvailability.querySelector('.in-stores').classList.add('d-none');
            const sidePanelTemplate = storeAvailability.querySelector('.side-panel-wrapper-template');
            const sidePanel = document.querySelector('.side-panel-wrapper');
            // overwrite side panel with content from updated template
            if (sidePanelTemplate) sidePanel.innerHTML = sidePanelTemplate.innerHTML;
            // Event listeners have to be added after the side panel is rendered
            const closeSidePanelList = document.querySelectorAll('[close-side-panel]');
            closeSidePanelList.forEach((closeElem)=>{
                closeElem.addEventListener('click', ()=>triggerSidePanel(false));
            });
            const enableLocation = document.querySelector('.side-panel-wrapper [enable-location]');
            enableLocation && enableLocation.addEventListener('click', ()=>sortByLocationInKm(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold));
        }
        function sortByLocationInKm(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold) {
            const deg2rad = (deg)=>{
                return deg * (Math.PI / 180);
            };
            const round = (value, precision)=>{
                var multiplier = Math.pow(10, precision || 0);
                return Math.round(value * multiplier) / multiplier;
            };
            // get user location and render pickup locations sorted by distance
            if (navigator.geolocation) navigator.geolocation.getCurrentPosition((position)=>{
                const lat2 = position.coords.latitude;
                const lon2 = position.coords.longitude;
                const R = 6371 // Radius of the earth in km
                ;
                availablePickupLocations = availablePickupLocations.map((location)=>{
                    const lat1 = location.address.latitude;
                    const lon1 = location.address.longitude;
                    const dLat = deg2rad(lat2 - lat1) // deg2rad below
                    ;
                    const dLon = deg2rad(lon2 - lon1);
                    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    const distance = R * c // Distance in km
                    ;
                    return {
                        address: location.address,
                        id: location.id,
                        name: location.name,
                        distance: round(distance, 1)
                    };
                });
                const availablePickupLocationsSorted = availablePickupLocations.sort((a, b)=>a.distance - b.distance);
                renderLocationsSorted(availablePickupLocationsSorted, availableVariantInventory, inventoryNoticeThreshold);
            }, (error)=>{
                // Handle errors, e.g. user denied location sharing permissions
                console.error("Error getting user location:", error);
            });
            else console.log("Geolocation is not supported by this browser.");
        }
        function renderLocationsSorted(availablePickupLocationsSorted, availableVariantInventory, inventoryNoticeThreshold) {
            let locations = document.querySelector('.side-panel-wrapper .pickup-locations');
            let firstChild = locations.firstElementChild;
            while(firstChild){
                firstChild.remove();
                firstChild = locations.firstElementChild;
            }
            // Update pickup locations in side panel popup
            const temp = document.querySelector("template.pickup");
            const itemHtml = temp.content.querySelector(".pickup-location");
            availablePickupLocationsSorted.map((location)=>{
                const variantLevel = availableVariantInventory.find((vLevel)=>vLevel.name === location.name).level;
                const noticeColor = variantLevel > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low';
                const node = document.importNode(itemHtml, true);
                node.querySelector('.product-inventory-notice').classList.add('product-inventory-notice--' + noticeColor);
                node.querySelector('.location-name').textContent = location.name;
                if (location.distance) node.querySelector('.pickup-location__distance').textContent = '(' + location.distance + 'km)';
                node.querySelector('.pickup-location__items').textContent = variantLevel;
                node.querySelector('.pickup-location__address .address1').textContent = location?.address?.address1;
                node.querySelector('.pickup-location__address .zip').textContent = location?.address?.zip;
                node.querySelector('.pickup-location__address .city').textContent = location?.address?.city;
                locations.appendChild(node);
            });
        }
        function triggerSidePanel(open) {
            const productRecommendations = document.querySelectorAll('product-recommendations');
            const recentlyViewedProducts = document.querySelectorAll('recently-viewed-products');
            const sidePanel = document.querySelector('.side-panel-wrapper .side-panel');
            if (open) {
                sidePanel.classList.add('active');
                document.getElementsByTagName('body')[0]?.classList.add('overflow-hidden');
                document.getElementsByClassName('header-section')[0]?.classList.add('transition-none');
                for (const pr of productRecommendations)pr.classList.add('-z-1', 'position-relative');
                for (const rvp of recentlyViewedProducts)rvp.classList.add('-z-1', 'position-relative');
            } else {
                sidePanel.classList.remove('active');
                document.getElementsByTagName("body")[0]?.classList.remove('overflow-hidden');
                document.getElementsByClassName('header-section')[0]?.classList.remove('transition-none');
                for (const pr of productRecommendations)pr.classList.remove('-z-1', 'position-relative');
                for (const rvp of recentlyViewedProducts)rvp.classList.remove('-z-1', 'position-relative');
            }
        }
        document.addEventListener('productAndVariantsInventoryOnLoad', productAndVariantsInventoryOnLoad);
        document.addEventListener('product:variant-change', function(e) {
            const variantID = e.detail.variant.id;
            document.addEventListener('productOnChange', productOnChange);
            function productOnChange(event) {
                handleVariantInventory(event, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, variantID);
                document.removeEventListener('productOnChange', productOnChange);
            }
        });
    }
})();


(function() {
    const inventoryData = document.querySelector("#inventory-quantity");
    if (!inventoryData) return;
    const inventoryContent = inventoryData.textContent.trim();
    if (!isJson(inventoryContent)) return;
    const inventoryParsed = JSON.parse(inventoryContent);
    const deliveryInStockContainer = document.querySelector(".delivery_in_stock");
    const deliveryNoStockContainer = document.querySelector(".delivery_no_stock");
    const currentVariantID = inventoryParsed["currentVariant"];
    const addToCartText = inventoryParsed["addToCartText"];
    const preorderText = inventoryParsed["preorderText"];
    const soldOutText = inventoryParsed["soldOutText"];
    const bundleProductsSize = inventoryParsed["bundleProductsSize"].length || 0;
    const timeTranslations = document.querySelector(".countdown_digits");
    if (!timeTranslations) return;
    const translationHours = timeTranslations.dataset.countHours;
    const translationMinutes = timeTranslations.dataset.countMinutes;
    const translationSeconds = timeTranslations.dataset.countSeconds;
    const addToCartButton = document.querySelector("#AddToCart");
    const addToCartButtonText = document.querySelector("#AddToCart span");
    if (!deliveryInStockContainer || !deliveryNoStockContainer || !addToCartButton) return;
    function isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    function showDeliveryOptions(variantId, isInStock) {
        const { inventoryPolicy: inventoryPolicy, preorder: preorder } = inventoryParsed[variantId];
        const isContinueselling = inventoryPolicy === "continue";
        const isPreorder = preorder === "true";
        if (isInStock) {
            deliveryInStockContainer.classList.remove("d-none");
            deliveryNoStockContainer.classList.add("d-none");
            addToCartButtonText.textContent = addToCartText;
        } else if (isPreorder && isContinueselling) {
            deliveryInStockContainer.classList.add("d-none");
            deliveryNoStockContainer.classList.add("d-none");
            addToCartButton.style.backgroundColor = "#000";
            addToCartButton.style.color = "#fff";
            addToCartButtonText.textContent = preorderText;
        } else if (!isPreorder && isContinueselling) {
            deliveryInStockContainer.classList.add("d-none");
            deliveryNoStockContainer.classList.remove("d-none");
            addToCartButtonText.textContent = addToCartText;
        } else if (!isContinueselling) {
            deliveryInStockContainer.classList.add("d-none");
            deliveryNoStockContainer.classList.add("d-none");
            addToCartButtonText.textContent = soldOutText;
        }
    }
    function renderShippingCountdown(event, currentVariantID) {
        const { variantsInventoryLevels: variantsInventoryLevels, product: { product: product } } = event.detail;
        if (!variantsInventoryLevels) return;
        const currentVariant = variantsInventoryLevels.find((inventory)=>inventory.id.includes(currentVariantID));
        let isInStock = currentVariant.inventory_quantities.find(({ level: level })=>level > 0) ? true : false;
        // Check if product is bundle and if so, check if product quantity is greater than 0
        const currentVariantId = currentVariant.id;
        const isBundleInStock = product.variants.find(({ admin_graphql_api_id: admin_graphql_api_id })=>admin_graphql_api_id === currentVariantId).inventory_quantity > 0;
        if (!isInStock && bundleProductsSize >= 2 && isBundleInStock) isInStock = true;
        showDeliveryOptions(currentVariantID, isInStock);
    }
    let deliveryCountdown = setInterval(function() {
        let currentTime = new Date();
        let dayOfWeek = currentTime.getDay();
        let isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        if (isWeekend) {
            deliveryInStockContainer.querySelector('.countdown_timer').classList.add('d-none');
            return false;
        }
        let denmarkTime = new Intl.DateTimeFormat("en-US", {
            timeZone: "Europe/Copenhagen",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        }).format(currentTime);
        let [dkHours, dkMinutes, dkSeconds] = denmarkTime.split(":");
        let diffHour = 14 - dkHours;
        let diffMin = 59 - dkMinutes;
        let diffSec = 59 - dkSeconds;
        if (diffHour >= 0 && diffMin >= 0 && diffSec >= 0) {
            deliveryInStockContainer.querySelector(".countdown_digits").innerHTML = `
          ${diffHour}${translationHours}:
          ${diffMin}${translationMinutes}:
          ${diffSec}${translationSeconds}
      `;
            deliveryInStockContainer.querySelector(".countdown_timer").classList.remove("d-none");
            deliveryInStockContainer.querySelector(".countdown_expected").classList.add("d-none");
        } else {
            deliveryInStockContainer.querySelector(".countdown_timer").classList.add("d-none");
            deliveryInStockContainer.querySelector(".countdown_expected").classList.remove("d-none");
        }
    }, 1000);
    document.addEventListener("DOMContentLoaded", ()=>{
        if (!currentVariantID) return;
        function handleVariantStockOnLoad(event) {
            renderShippingCountdown(event, currentVariantID);
            document.removeEventListener('productAndVariantsInventoryOnLoad', handleVariantStockOnLoad, false);
        }
        document.addEventListener('productAndVariantsInventoryOnLoad', handleVariantStockOnLoad);
    });
    document.addEventListener("product:variant-change", function(e) {
        const variantId = e.detail.variant.id;
        if (!variantId) return;
        function handleVariantStockOnChange(event) {
            renderShippingCountdown(event, variantId);
            document.removeEventListener('productOnChange', handleVariantStockOnChange, false);
        }
        document.addEventListener('productOnChange', handleVariantStockOnChange);
    });
})();


(function() {
    const variantPicker = document.querySelector(".product-information .variant-picker");
    if (!variantPicker) return;
    document.addEventListener("DOMContentLoaded", async ()=>{
        function handleVariantPickerOnLoad(event) {
            // Get variants and variantsInventoryLevels
            renderNewVariants(event, isOnLoad = true);
            document.removeEventListener('productAndVariantsInventoryOnLoad', handleVariantPickerOnLoad, false);
        }
        document.addEventListener('productAndVariantsInventoryOnLoad', handleVariantPickerOnLoad);
    });
    document.addEventListener("product:variant-change", ()=>{
        function handleVariantPickerOnChange(event) {
            renderNewVariants(event);
            document.removeEventListener('productOnChange', handleVariantPickerOnChange);
        }
        document.addEventListener('productOnChange', handleVariantPickerOnChange);
    });
    function isVariantAvailable(variantsInventoryLevels, index, inventoryPolicy) {
        const res = variantsInventoryLevels[index].inventory_quantities.find(({ level: level })=>level > 0) || -1;
        if (res === -1) {
            if (inventoryPolicy === 'continue') return true;
            else return false;
        } else return true;
    }
    function clearVariantPickerAndGetCheckedVariant(variantPicker) {
        let firstChild = variantPicker.firstElementChild;
        let checkedVariant = null;
        while(firstChild){
            if (firstChild.checked) checkedVariant = firstChild.value;
            firstChild.remove();
            firstChild = variantPicker.firstElementChild;
        }
        return checkedVariant;
    }
    function renderNewVariants(event, isOnLoad1 = false) {
        const template = document.querySelector('template#size-variant-template');
        if (!template) return;
        const { product: { product: { variants: variants } }, variantsInventoryLevels: variantsInventoryLevels } = event.detail;
        const { content: content } = template;
        const variantInput = content.querySelector('input');
        const variantLabel = content.querySelector('label');
        const { dataset: { section_id: section_id, optionPosition: optionPosition, sticky: sticky } } = variantInput;
        // Clear variant picker and get checked variant
        if (!variants) return;
        const checkedVariant = clearVariantPickerAndGetCheckedVariant(variantPicker);
        document.querySelector('.variations .form__label__value').innerText = checkedVariant;
        let isFirstVariant = true;
        variants.forEach((variant, index)=>{
            // Construct new variant input and label
            const variantInputClone = variantInput.cloneNode(true);
            variantInputClone.setAttribute('id', `${section_id}-${optionPosition}-${index}${sticky ? '--sticky' : ''}`);
            variantInputClone.setAttribute('form', `product-form-${section_id}`);
            variantInputClone.setAttribute('value', variant.title);
            if (variant.title === checkedVariant) variantInputClone.setAttribute('checked', true);
            const variantLabelClone = variantLabel.cloneNode(true);
            variantLabelClone.setAttribute('for', `${section_id}-${optionPosition}-${index}${sticky ? '--sticky' : ''}`);
            variantLabelClone.querySelector('span').innerText = variant.title;
            variantLabelClone.setAttribute('data-index', index);
            variantPicker.appendChild(variantInputClone);
            // Variants inventory and product variants come in the same order so we can use the same index
            // The variant will be labeled as "sold-out" if no store has it in stock 
            if (!isVariantAvailable(variantsInventoryLevels, index, variant.inventory_policy)) {
                variantLabelClone.classList.add('sold-out');
                variantPicker.appendChild(variantLabelClone);
            } else variantPicker.appendChild(variantLabelClone);
            if (isFirstVariant && isOnLoad1) isFirstVariant = false;
        });
        variantPicker.classList.remove('hide-default-variants');
    }
})();


function $b9b9399f6cfc3d34$var$toggleFacets() {
    el = document.getElementById('clerk-facets-container');
    if (el) el.classList.toggle('active');
}


// In case a user alredy has these variables set in cart
(async ()=>{
    try {
        fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: '{ "attributes": { "x-pa-pacid": "", "x-pa-id": "" } }'
        });
    } catch (error) {
        console.log(error);
    }
})();
async function $a58a0d753db6f90d$var$init() {
    const checkoutForm = document.querySelector(`[action="${theme.routes.cart_url}"]`);
    if (!checkoutForm) return;
    let callback = function(mutationsList, observer) {
        for (var mutation of mutationsList)if (mutation.type === 'childList') mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.matches('[name*="x-pa-"]')) node.remove();
        });
    };
    const observer = new MutationObserver(callback);
    const config = {
        attributes: false,
        childList: true,
        subtree: true
    };
    observer.observe(checkoutForm, config);
    // In case it's somehow already loaded
    const paInputs = checkoutForm.querySelectorAll('[name*="x-pa-"]');
    paInputs.forEach((input)=>input.remove());
}
document.addEventListener('cart-drawer:rendered', ()=>{
    $a58a0d753db6f90d$var$init();
});



})();
//# sourceMappingURL=parcel_scripts.js.map
